"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css2 = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobile = _useDeviceData.isMobile;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var tabInlinePadding = 20;
  var calcHorizontalPosition = (0, _react.useCallback)(function (tabs, selectedTabId) {
    var _tabs$;
    // Keep tabInlinePadding aligned with pxToRem proportions
    var horizontalPosition = 0;
    var firstTab = tabs !== null && tabs !== void 0 && tabs.length && (_tabs$ = tabs[0]) !== null && _tabs$ !== void 0 && _tabs$.id ? document.querySelector("#tab_".concat(tabs[0].id, " button")) : null;
    var selectedTab = document.querySelector("#tab_".concat(selectedTabId, " button"));
    if (selectedTab && firstTab) {
      horizontalPosition = direction === 'ltr' ? selectedTab.getBoundingClientRect().left - firstTab.getBoundingClientRect().left : firstTab.getBoundingClientRect().right - selectedTab.getBoundingClientRect().right;
    }
    return horizontalPosition;
  }, [direction]);
  var ccTabsStyle = (0, _react.useMemo)(function () {
    var ccTabs = (0, _css2.css)({
      position: 'relative',
      width: '100%',
      display: 'flex',
      padding: "".concat(pxToRem(1), " 0"),
      overflowX: isMobile ? 'scroll' : 'hidden',
      fontFamily: fontFamily,
      fontSize: basicFontSize,
      '::-webkit-scrollbar': {
        width: 0,
        height: 0
      }
    });
    var ccTabsList = (0, _css2.css)({
      padding: 0,
      margin: 0,
      listStyle: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      display: 'flex'
    });
    var ccTabsTab = (0, _css2.css)({
      float: 'right',
      paddingInline: pxToRem(tabInlinePadding),
      paddingBottom: pxToRem(3),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      ':first-of-type': {
        paddingInlineStart: 0
      }
    });
    var ccTabsTabHidden = (0, _css2.css)({
      paddingInline: pxToRem(tabInlinePadding),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text
    });
    var ccTabsTabLabel = (0, _css2.css)({
      whiteSpace: 'nowrap'
    });
    var ccTabsTabDots = (0, _css2.css)({
      transform: 'rotate(90deg)',
      display: 'inline-block',
      marginInlineEnd: pxToRem(3),
      letterSpacing: pxToRem(0.5),
      fontSize: pxToRem(15)
    });
    var ccTabsSlider = function ccTabsSlider(selectedTabId, tabs) {
      var prop = direction === 'rtl' ? 'right' : 'left';
      var selectedTab = document.querySelector("#tab_".concat(selectedTabId, " button"));
      var horizontalPosition = calcHorizontalPosition(tabs, selectedTabId);
      var sliderHeight = 2;
      if (selectedTab) {
        var _css;
        var rect = selectedTab.getBoundingClientRect();
        return (0, _css2.css)((_css = {
          boxSizing: 'content-box',
          fontSize: 1,
          width: rect.width,
          bottom: 0,
          height: pxToRem(sliderHeight),
          top: "calc(100% - ".concat(pxToRem(sliderHeight), ")")
        }, _defineProperty(_css, prop, horizontalPosition), _defineProperty(_css, "position", 'absolute'), _defineProperty(_css, "backgroundColor", themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main), _defineProperty(_css, "transition", "width 0.5s ease, ".concat(prop, " 0.5s ease")), _css));
      }
    };
    return {
      ccTabs: ccTabs,
      ccTabsList: ccTabsList,
      ccTabsTab: ccTabsTab,
      ccTabsTabHidden: ccTabsTabHidden,
      ccTabsTabLabel: ccTabsTabLabel,
      ccTabsTabDots: ccTabsTabDots,
      ccTabsSlider: ccTabsSlider
    };
  }, [basicFontSize, calcHorizontalPosition, direction, fontFamily, isMobile, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-Tabs': ccTabsStyle.ccTabs,
    'cc-Tabs__list': ccTabsStyle.ccTabsList,
    'cc-Tabs__tab': ccTabsStyle.ccTabsTab,
    'cc-Tabs__tab--hidden': ccTabsStyle.ccTabsTabHidden,
    'cc-Tabs__tab__label': ccTabsStyle.ccTabsTabLabel,
    'cc-Tabs__tab__dots': ccTabsStyle.ccTabsTabDots,
    'cc-Tabs__slider': ccTabsStyle.ccTabsSlider
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;